import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertQuery, AlertService } from '@fgb/core';
import { tap } from 'rxjs/operators';
import { EntityAlertModel } from 'projects/core/src/lib/modules/account/alert/models/entity-alert.model';

@Component({
  selector: 'fgb-alert-preferences',
  templateUrl: './alert-preferences.component.html',
  styleUrls: ['./alert-preferences.component.scss'],
})
export class AlertPreferencesComponent implements OnInit {
  @Input() editMode = false;
  @Input() portalId: string;
  alerts: EntityAlertModel[];
  alerts$: Observable<EntityAlertModel[] | undefined>

  constructor(private alertQuery: AlertQuery, private alertService: AlertService) {}

  ngOnInit() {
    this.alertService.fetchUserAlertPreferences().toPromise();
    this.alerts$ = this.alertQuery.selectAlerts().pipe(tap(alerts => {
      this.alerts = JSON.parse(JSON.stringify(alerts));
    }));
  }

  saveAlertPreferences(){
    this.alertService.updateUserAlertPreferences(this.alerts as EntityAlertModel[], this.portalId);
  }
}
